"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var GregorianDate_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GregorianDate = void 0;
const date_1 = require("../util/date");
const floor_math_1 = require("../util/floor-math");
const static_implements_1 = require("../util/static-implements");
const custom_1 = require("./custom");
let GregorianDate = GregorianDate_1 = class GregorianDate extends custom_1.CustomDate {
    constructor(rawDate) {
        super();
        this.rawDate = rawDate;
    }
    static fromTime(time) {
        let rawDate = new Date(time);
        let date = new GregorianDate_1(rawDate);
        return date;
    }
    toTime() {
        let time = this.rawDate.getTime();
        return time;
    }
    static of(year, month, day, hours, minutes, seconds, milliseconds) {
        let rawDate = new Date(year, month - 1, day, hours, minutes, seconds, milliseconds);
        let date = new GregorianDate_1(rawDate);
        return date;
    }
    static ofHairia(hairia, hours, minutes, seconds, milliseconds) {
        let timeOfDay = custom_1.EPOCH_DATE.getTime() + (hairia - 1) * 86400000;
        let timeInDay = (hours !== null && hours !== void 0 ? hours : 0) * 3600000 + (minutes !== null && minutes !== void 0 ? minutes : 0) * 60000 + (seconds !== null && seconds !== void 0 ? seconds : 0) * 1000 + (milliseconds !== null && milliseconds !== void 0 ? milliseconds : 0);
        let time = timeOfDay + timeInDay;
        let date = GregorianDate_1.fromTime(time);
        return date;
    }
    getModifiedDate(shift) {
        return (shift) ? new Date(this.rawDate.getTime() - 6 * 3600000) : this.rawDate;
    }
    getYear(shift) {
        return this.getModifiedDate(shift).getFullYear();
    }
    getMonth(shift) {
        return this.getModifiedDate(shift).getMonth() + 1;
    }
    getDate(shift) {
        return this.getModifiedDate(shift).getDate();
    }
    getHairia(shift) {
        return floor_math_1.FloorMath.div(date_1.DateUtils.difference(this.getModifiedDate(shift), custom_1.EPOCH_DATE), 86400000) + 1;
    }
    getHours(shift) {
        return this.getModifiedDate(shift).getHours() + ((shift) ? 6 : 0);
    }
    getMinutes(shift) {
        return this.getModifiedDate(shift).getMinutes();
    }
    getSeconds(shift) {
        return this.getModifiedDate(shift).getSeconds();
    }
    getMilliseconds(shift) {
        return this.getModifiedDate(shift).getMilliseconds();
    }
};
GregorianDate = GregorianDate_1 = __decorate([
    static_implements_1.staticImplements(),
    __metadata("design:paramtypes", [Date])
], GregorianDate);
exports.GregorianDate = GregorianDate;
